import { Routes } from '@angular/router'

import { AvailabilityComponent } from '../equipment/availability/availability.component'
import { FeatureType, RouteUtil } from '../shared'
import { LeadershipTeamVisitsComponent } from './leadership-team-visits/leadership-team-visits.component'
import { BonusTableComponent } from './bonus-table/bonus-table.component'
import { FirmContactsComponent } from './firm-contacts/firm-contacts.component'
import { FteProjectionsComponent } from './fte-projections/fte-projections.component'
import { JobOwnershipTemplatesComponent } from './job-ownership-templates/job-ownership-templates.component'
import { JobOwnershipsComponent } from './job-ownerships/job-ownerships.component'
import { MaterialAnalyticsComponent } from './material-analytics/material-analytics.component'
import { MaterialsComponent } from './materials/materials.component'
import { PmJcaReportComponent } from './pm-jca-report/pm-jca-report.component'
// DEPRECATED: ProductivityAnalysisComponent is deprecated. Use ProductivitySummaryComponent instead.
import { ProductivityAnalysisComponent } from './productivity-analysis/productivity-analysis.component'
import { ManpowerOutliersComponent } from './manpower-outliers/manpower-outliers.component'
import { ProductivitySummaryComponent } from './productivity-summary/productivity-summary.component'
import { ProjectedHoursComponent } from './projected-hours/projected-hours.component'
import { MonthlyProjectionPlansComponent } from './projections/monthly-plans/monthly-plans.component'
import { ProjectionsComponent } from './projections/projections.component'
import { RentalsComponent } from './rental/rentals.component'
import { SchedulingComponent } from './scheduling/scheduling.component'
import { WipReportComponent } from './wip-report/wip-report.component'

export const operationsRoutes: Routes = [
    {
        path: 'operations',
        children: [
            RouteUtil.Make('availability', AvailabilityComponent, FeatureType.EquipmentAvailabilityView),
            RouteUtil.Make('rentals', RentalsComponent, FeatureType.OperationsRentalsView),
            RouteUtil.Make('materials', MaterialsComponent, FeatureType.OperationsMaterialsView),
            RouteUtil.Make('scheduling', SchedulingComponent, FeatureType.OperationsSchedulingView),
            RouteUtil.Make('projections', ProjectionsComponent, FeatureType.OperationsProjectionsView),
            RouteUtil.Make('fte-projections', FteProjectionsComponent, FeatureType.OperationsProjectionsView),
            RouteUtil.Make('bonus-table', BonusTableComponent, FeatureType.OperationsBonusTableViewEdit),
            RouteUtil.Make('monthly-plans', MonthlyProjectionPlansComponent, FeatureType.OperationsProjectionsView),
            RouteUtil.Make('material-analytics', MaterialAnalyticsComponent, FeatureType.OperationsMaterialsView),
            RouteUtil.Make('job-ownership-templates', JobOwnershipTemplatesComponent, FeatureType.OperationsJobOwnershipTemplatesView),
            RouteUtil.Make('job-ownerships', JobOwnershipsComponent, FeatureType.OperationsJobOwnershipTemplatesView),
            RouteUtil.Make('wip-report', WipReportComponent, FeatureType.OperationsWipReportView),
            RouteUtil.Make('projected-hours', ProjectedHoursComponent, FeatureType.OperationsProjectionsView),
            RouteUtil.Make('pm-jca-report', PmJcaReportComponent, FeatureType.OperationsPmJcaReportView),
            // DEPRECATED: Productivity Analysis route is deprecated. Use Productivity Summary instead.
            // RouteUtil.Make('productivity-analysis', ProductivityAnalysisComponent, FeatureType.OperationsProjectionsView),
            RouteUtil.Make('productivity-summary', ProductivitySummaryComponent, FeatureType.ProjectManagementProductivityView),
            RouteUtil.Make('manpower-outliers', ManpowerOutliersComponent, FeatureType.OperationsManpowerOutliersView),
            RouteUtil.Make('firm-contacts', FirmContactsComponent, FeatureType.OperationsMaterialsView),
            RouteUtil.Make('leadership-team-visits', LeadershipTeamVisitsComponent, [
                FeatureType.OperationsLeadershipTeamVisitsView,
                FeatureType.OperationsLeadershipTeamVisitsDashboardView,
            ]),
        ],
    },
]
